<template>
  <div>
    <div slot="header" class="clearfix infoNo">
      <div>请扫描发货单号:</div>
      <div>
        <el-input
          v-model="shipmentNnumber"
          @keyup.enter.native="init"
        ></el-input>
      </div>
    </div>
    <div class="infoRowParent">
      <div class="infoRow infoRowFirst">
        <div>发货单号： {{ OutboundInfo.outboundNo }}</div>
        <div>参考单号： {{ OutboundInfo.orgOutboundNo }}</div>
        <div>仓库： {{ OutboundInfo.warehouseName }}</div>
      </div>
      <div class="infoRow">
        <div>出库单状态： {{ OutboundInfo.outboundStatusText }}</div>
        <div>总箱数： {{ OutboundInfo.boxCount }}</div>
        <div>已出库箱数： {{ OutboundInfo.sendBoxCount }}</div>
      </div>
    </div>

    <el-card v-show="isShowScanNoSend" class="scanContant">
      <!-- <div>箱子数据： {{ boxList }}</div> -->
      <div class="scanningNo">
        <span>请扫描箱号：</span
        ><el-input
          id="scanBox"
          v-model.trim="scanBoxNo"
          @keyup.enter.native="getTableList"
        ></el-input>
        <span v-if="showNoMatch" class="noMatch">未匹配到箱号，请确认</span>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="customerBox" label="箱号" width="180">
        </el-table-column>
        <el-table-column prop="actualBoxWeight" label="毛重（kg）" width="180">
        </el-table-column>
        <el-table-column prop="actualBoxVolume" label="体积（cbm）">
        </el-table-column>
        <el-table-column prop="actualBoxLength" label="长（cm）">
        </el-table-column>
        <el-table-column prop="actualBoxWidth" label="宽（cm）">
        </el-table-column>
        <el-table-column prop="actualBoxHeight" label="高（cm）">
        </el-table-column>
      </el-table>
      <div class="locationContainer">
        <span>选择库位：</span>
        <el-select
          v-model="storages"
          style="width: 200px"
          placeholder="请选择库位"
          multiple
          clearable
          filterable
        >
          <el-option
            v-for="item in OutboundInfo.locationList"
            :label="item.locationCode"
            :value="item.locationCode"
            :key="item.locationCode"
          ></el-option>
        </el-select>
      </div>
    </el-card>
    <el-card
      shadow="hover"
      style="margin-top: 10px; width: 100%"
      v-if="this.viewtype > 0"
    >
      <div style="text-align: center">
        <el-button type="danger" @click="scanNoSend">录入未发</el-button>
        <el-button type="success" @click="passLoadingReview"
          >确认发货</el-button
        >
        <el-button type="danger" @click="cancelDalog">取消</el-button>
      </div>
    </el-card>
    <el-dialog
      append-to-body
      title="完成装车"
      :visible.sync="showPhotoModel"
      @close="close"
      :center="true"
    >
      <div style="font-size: 15px; font-weight: 600; margin-bottom: 10px">
        出库{{ num1s || 0 }}箱，未出库{{ num2s || 0 }}箱。
      </div>
      <div class="demo-image">
        <ul v-for="(item, i) in photoList" :key="i">
          <div v-for="(item2, i2) in item" :key="i2" class="image-box">
            <p>
              <span style="color: red" v-if="item2.required">*</span
              >{{ item2.text }}
            </p>
            <div
              class="sign-photo-item"
              v-if="imgObj[item2.name]"
              @mouseover="imgMouseOver(i, i2)"
              @mouseleave="imgMouseLeave(i, i2)"
            >
              <div class="del-box" v-if="item2.showControl">
                <i
                  class="el-icon-zoom-in"
                  style="margin-right: 10px"
                  @click="showImg(imgObj[item2.name])"
                ></i>
                <i class="el-icon-delete" @click="deleteImg(item2.name)"></i>
              </div>
              <div class="loading-box" v-if="item2.loading">
                <i class="el-icon-loading"></i>
              </div>
              <img
                :src="imgObj[item2.name]"
                class="sign-photo-item-img"
                alt=""
              />
            </div>

            <div class="sign-photo-btn" v-else>
              <div class="photo">
                <input
                  class="img hidden"
                  @change="changeImg(i, i2)"
                  type="file"
                  name="cover"
                  ref="inputer"
                  accept="image/*"
                />
                <p @click="chooseImage(item2.id)" class="photo-s">
                  <i class="el-icon-picture-outline"></i>
                </p>
              </div>
            </div>
          </div>
        </ul>

        <el-dialog
          :visible.sync="dialogVisible"
          width="60%"
          :modal="false"
          :center="true"
          append-to-body
          custom-class="imgPreview"
        >
          <img height="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确认装车</el-button>
        <el-button @click="showPhotoModel = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getOutboundSendDetail,
  overSendSubmit,
  getOutboundSendBoxDetail,
} from "@/api/outbound/outboundOrder.js";

import axios from "axios";
import { BaseApiUrl } from "@/api/axios_config";
export default {
  props: ["outboundNoDalog", "viewtypeDalog"],
  data() {
    return {
      showNoMatch: false,
      shipmentNnumber: "",
      scanBoxNo: "",
      dialogVisible: false,
      tableData: [],
      dialogImageUrl: "",
      IsShowDeliver: true,
      OutboundInfo: {},
      srcList: [],
      storages: [],
      refusedialogVisible: false,
      RefuseReason: "",
      viewtype: 0,
      form: {},
      locationList: [],
      isShowScanNoSend: false,
      boxList: [],
      showPhotoModel: false,
      num1s: 0,
      num2s: 0,
      imgObj: {
        // 图片类型 1.车牌照 2.空柜照 3.托运单 4.未关门照 5.半关门照 6关门照 7.锁封照 8.其他 9.其他1
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      },
      photoList: [
        [
          {
            name: "img1",
            text: "车牌照",
            id: 1,
            showControl: false,
            loading: false,
            required: true,
          },
          {
            name: "img2",
            text: "空柜照",
            id: 2,
            showControl: false,
            loading: false,
            required: true,
          },
          {
            name: "img3",
            text: "托运单",
            id: 3,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
        [
          {
            name: "img4",
            text: "未关门照",
            id: 4,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img5",
            text: "半关门照",
            id: 5,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img6",
            text: "关门照",
            id: 6,
            showControl: false,
            loading: false,
            required: true,
          },
        ],
        [
          {
            name: "img7",
            text: "锁封照",
            id: 7,
            showControl: false,
            loading: false,
            required: true,
          },
          {
            name: "img8",
            text: "其他",
            id: 8,
            showControl: false,
            loading: false,
            required: false,
          },
          {
            name: "img9",
            text: "其他1",
            id: 9,
            showControl: false,
            loading: false,
            required: false,
          },
        ],
      ],
      imgFiles: [],
      saveImgUrlArr: [],
    };
  },
  created() {
    //this.init();
  },
  methods: {
    getTableList() {
      let flag = true;
      let newBoxList = this.boxList.map((item) => {
        if (item.customerBox == this.scanBoxNo) {
          this.tableData.push(item);
          flag = false;
          return {};
        } else {
          return item;
        }
      });
      if (flag) {
        this.showNoMatch = true;
      } else {
        this.showNoMatch = false;
      }
      this.boxList = newBoxList;
    },
    cancelDalog() {
      this.$emit("cancelDalog", "");
    },
    clearImgModel() {
      this.imgObj = {
        img1: "",
        img2: "",
        img3: "",
        img4: "",
        img5: "",
        img6: "",
        img7: "",
        img8: "",
        img9: "",
      };

      this.saveImgUrlArr = [];
    },
    close() {
      this.clearImgModel();
      this.showPhotoModel = false;
    },

    imgMouseOver(i, i2) {
      this.$set(this.photoList[i][i2], "showControl", true);
    },

    imgMouseLeave(i, i2) {
      this.$set(this.photoList[i][i2], "showControl", false);
    },

    deleteImg(type) {
      this.$set(this.imgObj, type, "");

      this.saveImgUrlArr.forEach((item, i) => {
        const m = type.split("")[3];
        if (m == item.imageType) {
          this.saveImgUrlArr.splice(i, 1);
        }
      });
    },

    showImg(base64Url) {
      this.dialogVisible = true;
      this.dialogImageUrl = base64Url;
    },

    changeImg(i, i2) {
      const img = document.getElementsByClassName("img")[0];

      if (!img.files.length) return;

      this.handleFiles(img.files);

      let imgList = [...img.files];

      this.imgFiles.push(...imgList);

      this.toUpload(i, i2);
    },

    chooseImage(num) {
      console.log("num=", num);
      this.currentImg = num;
      document.getElementsByClassName("img")[0].value = "";
      document.getElementsByClassName("img")[0].click();
    },

    handleFiles(files) {
      const that = this;

      var file = files;

      const { type, name } = file[0];

      var imageType = /^image\//;
      if (!imageType.test(type)) {
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        that.$set(that.imgObj, `img${that.currentImg}`, e.target.result);
      };
      reader.readAsDataURL(file[0]);
    },

    toUpload(i, i2) {
      const that = this;
      let formDatas = new FormData();

      this.imgFiles.forEach((i, index) => {
        formDatas.append("files", i);
      });

      const s = this.currentImg;
      this.$set(this.photoList[i][i2], "loading", true);

      axios({
        url: `${BaseApiUrl}/Img/InsertFtpImage`,
        method: "post",
        data: formDatas,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((res) => {
        this.$set(this.photoList[i][i2], "loading", false);
        if (res.data.status === 200 && res.data.success) {
          console.log("this.currentImg=", this.currentImg);
          this.saveImgUrlArr.push({
            imageUrl: res.data.response[0].urlPath,
            imageType: s,
          });
          this.imgFiles = [];
        } else {
          this.$message({
            message: "图片上传失败，请重试",
            type: "error",
          });
        }
      });
    },

    passLoadingReview() {
      if (!this.storages.length && this.isShowScanNoSend) {
        this.$message({
          message: "请选择库位",
          type: "error",
        });
        return;
      }
      if (!this.tableData.length && this.isShowScanNoSend) {
        this.$message({
          message: "请扫描箱号",
          type: "error",
        });
        return;
      }

      this.showPhotoModel = true;
      this.saveImgUrlArr = [];

      // this.$confirm(remindBoxNum, "确认出库？", {})
      //           .then(() => {

      //             const loading = this.$loading({
      //               lock: true,
      //               text: "提交中，请稍等",
      //               spinner: "el-icon-loading",
      //               background: "rgba(0, 0, 0, 0.5)",
      //             });

      //             const para = {
      //               TFOutboundID: this.OutboundInfo.tfOutboundID,
      //               Storages: "",
      //               NoBoxIDs:"",
      //             };

      //             overSendSubmit(para).then((res) => {
      //               loading.close();

      //               if (res.success == true) {
      //                 this.$alert(res.msg, {
      //                   confirmButtonText: "确定",
      //                   callback: (action) => {
      //                     window.parent.postMessage("close", "*");
      //                   },
      //                 });
      //               } else {
      //                 this.$message({
      //                   message: res.msg,
      //                   type: "error",
      //                 });
      //                 return;
      //               }
      //             });
      //           })
      //           .catch((err) => {
      //             console.log(err);
      //           });
    },

    submit() {
      if (!this.saveImgUrlArr.length) {
        this.$message({
          message: "请上传带*号的必填图片",
          type: "error",
        });
        return;
      }

      let flag = false;
      this.photoList.forEach((item, i) => {
        item.forEach((item2, i2) => {
          let arr = [];
          this.saveImgUrlArr.forEach((item3, i) => {
            arr.push(item3.imageType);
          });
          if (item2.required && !arr.includes(item2.id)) {
            flag = true;
          }
        });
      });
      if (flag) {
        this.$message({
          message: "请上传带*号的必填图片",
          type: "error",
        });
        return;
      }
      let NoBoxIDsArr = this.tableData.map((item) => item.tfDeliveryBoxInfoID);
      const data = {
        TFOutboundID: this.OutboundInfo.tfOutboundID,
        Storages: this.storages.join(','), //  库位
        NoBoxIDs: NoBoxIDsArr.join(','), // 已扫码箱号
        imageUrls: this.saveImgUrlArr,
      };

      const loading = this.$loading({
        lock: true,
        text: "操作中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      console.log("data", data);
      overSendSubmit(data).then((res) => {
        loading.close();
        if (res.status === 200 && res.success) {
          this.$message({
            message: res.msg,
            type: "success",
          });

          this.clearImgModel();
          this.close();
          this.$emit("cancelDalog", "");
          this.$emit('searchTable','')
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    scanNoSend() {
      this.isShowScanNoSend = true;

      const para = {
        outboundID: this.OutboundInfo.tfOutboundID,
      };
      getOutboundSendBoxDetail(para).then((res) => {
        if (res.data.success == true) {
          this.boxList = res.data.response;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
          return;
        }
      });
    },

    init() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      const para = {
        outboundNo: this.shipmentNnumber,
      };

      this.viewtype = this.viewtypeDalog;

      getOutboundSendDetail(para).then((res) => {
        loading.close();
        console.info(res);
        if (res.data.response) {
          this.OutboundInfo = res.data.response;
        } else {
          this.OutboundInfo = {};
          this.$message({
            message: "出库单号错误,请确认",
            type: "error",
          });
        }
      });
    },
  },
  mounted() {
    this.shipmentNnumber = this.outboundNoDalog;
    this.init();
  },
  watch: {},
};
</script>

<style scoped lang="less">
.infoNo {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  > div:first-child {
    margin-right: 12px;
  }
}
.infoRowParent {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  background-color: rgb(197, 199, 204);
  padding: 20px;
  border-radius: 4px;
  .infoRow {
    display: flex;
    justify-content: space-around;
    > div {
      width: 300px;
      text-align: left;
    }
  }
}
.scanContant {
  margin: 20px 0;
  .scanningNo {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .el-input {
      width: 200px;
    }
    > span {
      white-space: nowrap;
      margin-right: 10px;
    }
    .noMatch {
      color: red;
      display: inline-block;
      margin-left: 4px;
      font-size: 14px;
    }
  }
  .locationContainer {
    margin-top: 20px;
    display: flex;
    align-items: center;
    .el-input {
      width: 200px;
    }
    > span {
      white-space: nowrap;
      margin-right: 10px;
    }
  }
}
.infoRowFirst {
  margin-bottom: 20px;
}
.left-item {
  float: left;
  width: 20%;
  // min-width: 285px;
}
.left-item-card {
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;
}

el-input {
  width: 100px;
}

.left-item-card {
  &::-webkit-scrollbar {
    height: 6px;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(207, 210, 217);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgb(184, 182, 182);
  }
}
.image-box {
  float: left;
  width: 20%;
  text-align: center;
}
.sign-photo-btn {
  width: 100px;
  border: 1px dashed #ccc;
  margin: 0 auto;
  height: 100px;
  cursor: pointer;
}
.sign-photo-btn:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.sign-photo-item:hover {
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 15%);
}
.photo-s {
  color: #bfbfbf;
  padding: 23px 0;
  margin: 0;
  i {
    font-size: 55px;
  }
}
.sign-photo-item {
  height: 100px;
  width: 100px;
  margin: 0 auto;
  position: relative;
  img {
    height: 100px;
    width: 100px;
  }
}
.del-box {
  background-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    cursor: pointer;
    color: rgb(248, 248, 248);
    margin-top: 35px;
  }
}
.loading-box {
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 25px;
  i {
    color: rgb(224, 222, 222);
    margin-top: 35px;
  }
}
.hidden {
  display: none;
}
.demo-image {
  max-height: 500px;
  overflow: auto;
  > ul {
    display: flex;
    justify-content: space-around;
  }
}
</style>

<style>
.imgPreview {
  height: 50%;
  margin-top: 0 !important;
  height: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  transform: translate(-50%, -50%);
}
.imgPreview .el-dialog__body {
  height: calc(100% - 85px);
  text-align: center;
}
.all-status {
  /* text-align: end; */
  height: 43px;
  padding-top: 15px;
  float: left;
}

.all-right {
  text-align: end;
  height: 43px;
  padding-top: 15px;
  float: left;
  margin-right: 10px;
  margin-left: 200px;
}

.all-clear {
  clear: both;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>
